import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {store, persistor} from "./store/store";
import {Provider} from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

console.log("%cMade with 🍒 by Smartdev Agency", "font-size:11px; font-weight:bold; color:#fff; background-color:#662483; padding:6px 9px; border-radius:3px;");

root.render(
  // StricMode render twice (dev purpose)
  // <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
